import React from 'react';

import { Box, BoxProps, Step, StepContent, Stepper, StepperProps } from '@mui/material';
import { StepperState, useStepperState } from './hooks/useStepperState';
import { buildContentComponent, buildLabelComponent } from './utils/stepper-utils';

export type StepProps = {
  label: string | React.ReactNode;
  optional?: React.ReactNode;
  wrapper?: {
    props?: any;
    component?: any;
  };
  children: string | React.ComponentType<{ stepperState?: StepperState }>;
};

interface WizardStepperProps extends StepperProps {
  steps: StepProps[];
  // stepperSlice?: any;
  containerProps?: BoxProps;
  onFinish?: ((data) => any) | null;
}

export const WizardStepper = ({
  steps,
  // stepperSlice = null,
  containerProps = {},
  orientation,
  onFinish = null,
  nonLinear,
  ...rest
}: WizardStepperProps) => {
  const stepperState = useStepperState(steps, onFinish);

  const {
    activeStep,
    methods: { isStepCompleted, handleStep },
  } = stepperState;

  return (
    <Box {...containerProps}>
      <Stepper activeStep={activeStep} orientation={orientation} {...rest}>
        {steps.map((step, index) => {
          return (
            <Step key={index} completed={isStepCompleted(index)}>
              {buildLabelComponent(step, index, nonLinear, handleStep)}
              {orientation === 'vertical' && <StepContent>{buildContentComponent(step, stepperState)}</StepContent>}
            </Step>
          );
        })}
      </Stepper>
      {orientation !== 'vertical' && buildContentComponent(steps[activeStep], stepperState)}
    </Box>
  );
};
